/**
 * @generated SignedSource<<a79eaa312fbc75bd8343d7f396587391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CitySidebar_city$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "CitySidebar_city";
};
export type CitySidebar_city$key = {
  readonly " $data"?: CitySidebar_city$data;
  readonly " $fragmentSpreads": FragmentRefs<"CitySidebar_city">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CitySidebar_city",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "City",
  "abstractKey": null
};

(node as any).hash = "1b21d57c4cdb7dff85eff22b219e97b1";

export default node;
